import {useRef, useState, useEffect} from 'react';
import firebaseInit from 'firebase-init';
import {getOrientation, getAspectRatio} from 'helpers/device-helper';
import LoginController from './login/login-controller';
import './app.scss';

const App = () => {

	const appRef = useRef(null);
	const [languageId, setLanguageId] = useState('da');
	const [fontSize, setFontSize] = useState(null);

	const userRole = (
		window.location.pathname.toLowerCase().includes('gruppe') ||
		window.location.pathname.toLowerCase().includes('survey')
			? 'player' : 'facilitator'
	);

	/* Device info */
	const [deviceInfo, setDeviceInfo] = useState(() => {
		return {
			orientation: getOrientation(),
			aspectRatio: getAspectRatio()
		};
	});


	/**
	 * Calculate font size
	 */
	const calculateFontSize = () => {
		if (appRef.current) {
			const appElementWidth = appRef.current.clientWidth;
			const appElementHeight = appRef.current.clientHeight;
			if (appElementHeight > 100) { // make sure element is rendered
				const isWide = appElementWidth / appElementHeight >= 402 / 767.;
				let fontSize = 16 * (appElementWidth / 402.); // mobile first
				if (isWide) {
					fontSize = 16 * (appElementHeight / 767.);
				}
				setFontSize(fontSize);
			}
		}
	};

	/**
	 * User resized window, update orientation and aspect ratio
	 */
	const handleWindowResize = () => {
		const newDeviceInfo = JSON.parse(JSON.stringify(deviceInfo));
		newDeviceInfo.orientation = getOrientation();
		newDeviceInfo.aspectRatio = getAspectRatio();
		setDeviceInfo(newDeviceInfo);
		calculateFontSize();
	};
 
	/**
	 * Component mounted / will unmount
	 */
	useEffect(() => {
		/* Component mounted */ 

		/* Initialize firebase */
		firebaseInit();

		/* Add event listener for window size */
		if (document.addEventListener) {
			window.addEventListener('resize', handleWindowResize, false);
			window.addEventListener('deviceorientation', handleWindowResize, true);
		}
		

		/* Component will ummount */
		return () => {
			if (document.removeEventListener) {
				window.removeEventListener('resize', handleWindowResize, false);
				window.removeEventListener('deviceorientation', handleWindowResize, false);
			}
		};
	});


	const style = (userRole === 'player' && fontSize && fontSize > 0 ? {fontSize: fontSize + 'px'} : null);


	return (
		<div ref={appRef} id="App" className={'App ' + userRole} style={style}>
			<LoginController 
				languageId={languageId}
				deviceInfo={deviceInfo} 
				setLanguageId={setLanguageId}
				calculateFontSize={calculateFontSize}
			/>
		</div>
	);
};

export default App;
